import ajax from "./ajax";
import showMoreInit from "./show-more";
import sliderClassInit from "./slider-class";
import searchClassInit from "./search-class";
import pageBtnClassInit from "./page-class";
import compareClassInit from "./compare-class";
import accordionInit from "./accordion";
import cardShowInit from "./card-show";
import textSeachClassInit from "./text-search-class";
import caseSerachClassInit from "./case-search-class";
import paramInit from "./param-class";
import wpCaseRegexPostInit from "./wp-case-regex-post";
import tabMenuInit from "./tabmenu";
import suggestInit from "./suggest-class";
import caseSearchComponentClassInit from "./case-search-component";
import mainLoadingInit from "./main-loading";
import Remodal from "./remodal-class";
import followMenu from "./follow-menu";
import cookieInit from "./cookie";
import alertInit from "./alert";


export default function coreHandlerInit() {

  const themeSource = (function (scripts) {
    var scripts = document.getElementsByTagName('script'),
      script = scripts[scripts.length - 1];

    if (script.getAttribute.length !== undefined) {
      return script.src
    }

    return script.getAttribute('src', -1)
  }()).replace(/assets.+$/g, '');

  const resultBaseUrl = themeSource + 'data/result_base.json';
  const rangeBaseUrl = themeSource + 'data/range_base.json';
  const getPropUrl = themeSource + 'handler/get_prop.php';
  const modalUrl = themeSource + 'handler/modal.php';
  const wpFieldData = wpCaseRegexPostInit();



  const processResult = fetch(resultBaseUrl, {
    headers: {
      Accept: "application/json",
      mode: 'cors',
      "Content-Type": "application/json;charset=utf-8"
    }
  }).then(function (resolve) {
    return resolve.json();
  })
  const processRange = fetch(rangeBaseUrl, {
    headers: {
      Accept: "application/json",
      mode: 'cors',
      "Content-Type": "application/json;charset=utf-8"
    }
  }).then(function (resolve) {

    return resolve.json();
  });

  const processProp = fetch(getPropUrl, {
    mode: 'cors'
  }).then(response => response.json()).catch((reason) => {
    console.log(reason);
  });

  const wovnData = new Promise((resolve, reject) => {
    if (window.WOVN && WOVN.io && WOVN.io.isApiReady()) {
      resolve(WOVN.io.getCurrentLang());
    } else {
      window.addEventListener('wovnApiReady', function () {
        if (WOVN && WOVN.io && WOVN.io.isApiReady()) {
          resolve(WOVN.io.getCurrentLang());
        } else {
          reject(new Error("WOVN API is not ready"));
        }
      });
    }
  });

 


  return Promise.all([processResult, processRange, processProp, wpFieldData, wovnData]).then(function (response) {
    return response;

  }).then(function (processData) {

    const json = processData[0];
    const rangeJson = processData[1];
    const propJson = processData[2];
    const regexClass = processData[3];
    const wovnData = processData[4];

    // console.log("wovnData", wovnData );

    class coreHandler {
      static instanceList = [];
      constructor() {
        this.data = {
          CompareList: [],
          Selectors: [],
          Jsons: [{
              "name": "result",
              "json": json
            },
            {
              "name": "range",
              "json": rangeJson
            }
          ],
          //searchクリックからのtextタイプを利用した検索に対応するための保存配列
          wpExCaseList: regexClass.data,
          //開発中エラーのポストデータを追加するための配列
          errorPostList: [],
          caseErrorFlag: false
        };
        this.searchParam = paramInit(propJson, regexClass);
        this.regexClass = regexClass;
        this.searchClass = searchClassInit(this, this.searchParam);
        this.sliderClass = sliderClassInit(this, this.searchParam);
        this.textSearchClass = textSeachClassInit(this, this.searchParam, this.regexClass);
        this.caseSearchClass = caseSerachClassInit(this, this.searchParam, this.regexClass);
        this.caseSearchComponentClass = caseSearchComponentClassInit(this);
        this.pageBtnClass = pageBtnClassInit(this);
        this.compareClass = compareClassInit(this);
        this.showMoreClass = showMoreInit(this);
        this.followMenuClass = followMenu;
        this.loadingElement = document.querySelector(".js__loading");
        this.outputElement = document.querySelector("#js__out");
        this.tabMenuClass = tabMenuInit(this);
        this.suggestClass = suggestInit(this);
        this.remodalClass = Remodal;
        this.followMenuClass = followMenu;
        this.accordionClass = accordionInit(this.showMoreClass, this.textSearchClass, this.searchParam, this.followMenuClass);
        this.cookieClass = cookieInit();
        this.alertClass = alertInit(this.cookieClass, this.remodalClass);
        this.init = (() => {
          cardShowInit(this);
        })();
        this.firstSelect = null;
        this.recentEvent = null;

        this.followMenuClass.init();
      }


      static update = () => {
        this.outputElement = document.querySelector("#js__out");
      }
      
      searchSyncSelected = () => {
        let checkedItems = this.searchClass.getCheckedItems();
        this.suggestClass.syncSelectedItems(checkedItems);
      }


      addErrorPostList = (searchClassInstance) => {
        const postId = searchClassInstance.postId;
        const itemId = searchClassInstance.itemId;
        const taxChain = searchClassInstance.taxChain;

        // postId がすでに存在する場合は追加しない
        if (this.data.errorPostList.some(errorItem => errorItem.postId === postId && errorItem.itemId === itemId)) {
          return false;
        }

        // 新しいオブジェクトを配列に追加
        this.data.errorPostList.push({
          postId: postId,
          itemId: itemId,
          taxChain: taxChain
        });
      }

      removeErrorPostList = (searchClassInstance) => {
        const itemId = searchClassInstance.itemId;

        // errorPostList から一致する item を持つ要素を削除
        this.data.errorPostList = this.data.errorPostList.filter((errorItem) => {
          return errorItem.itemId !== itemId;
        });
      }

      loadingAnimation = (action) => {
        if (this.loadingElement === "undefined" || this.outputElement === "undefined") return false;
        if (action === "show") {
          this.outputElement.classList.remove("u-is-none", "u-is-show");
          this.loadingElement.classList.remove("u-is-none", "u-is-show");
          this.outputElement.classList.add("u-is-none");
          this.loadingElement.classList.add("u-is-show");
        } else if (action === "hidden") {
          this.loadingElement.classList.remove("u-is-none", "u-is-show");
          this.outputElement.classList.remove("u-is-none", "u-is-show");
          this.outputElement.classList.add("u-is-show");
          this.loadingElement.classList.add("u-is-none");
        }
      }


      allReset = (sendFlag = true) => {
        this.removeCaseErrorFlag();

        this.recentEvent = null;
        this.searchClass.allReset();
        this.sliderClass.allReset();
        this.textSearchClass.allReset();
        this.searchParam.allReset();
        this.accordionClass.allReset();
        this.caseSearchClass.allReset();
        this.data.Selectors = [];
        this.data.errorPostList = [];
        if (sendFlag !== true) return false;
        
        this.remodalClass.destroy();

        this.sendJson().then(result => {
          let resultJson = JSON.parse(result[0]);
          let apiResponse = JSON.parse(result[1]);

          
          //apiからレスポンスがあれば、ソースコードで帰ってくるため
          if( JSON.parse( result[1] ) ){


            //apiエラー処理（返り値はjson形式）
            try {
              apiResponse = JSON.parse(result[1]);
            } catch (error) {
              console.error("Failed to parse API response:", error);
              return Promise.reject('APIレスポンスの解析に失敗しました');
            }
      
            if (apiResponse && apiResponse.stat === 'error') {
              let errorMessage;
              let langCode = wovnData.code;
      
              if (langCode !== null && langCode === "en") {
                errorMessage = `The Data sheet and UL yellow card are currently experiencing difficulties in accessing the site. We apologize for any inconvenience caused.`;
              } else if (langCode !== null && langCode == "zh-CHS") {
                errorMessage = `物性参数表和UL黄卡目前在访问网站时遇到困难。我们对由此造成的不便深表歉意。`;
              } else {
                errorMessage = `物性表とUL Yellow cardは、ただいまアクセスしにくい状況が発生しております。ご不便をおかけして申し訳ありませんが、しばらく時間をおいて再度アクセスしてください。`;
              }
      
              // ローディングアニメーション画面の停止処理
              document.querySelector('.js__loading').remove();
  
              // アラートダイアログ表示
              alert(errorMessage);
  
              return Promise.reject('APIエラーが発生しました');
            }
          }


          // console.log( "-----",apiResponse );

          document.querySelector('#js__out').innerHTML = apiResponse["body"];
          document.querySelector('#js__modal').innerHTML = result[2];

          // this.mainLoading.start();
          coreHandler.update();

          return resultJson;
        }).then(result => {
          this.allRebuild(result);
        }).catch((e) => console.log( e ) );


      }
      allRebuild = (result) => {
        this.searchClass.rebuild(result);
        this.sliderClass.rebuild(result);
        this.compareClass.rebuild();
        this.pageBtnClass.init();
        showMoreInit(this);
        cardShowInit(this);
        this.tabMenuClass.rebuild();
        coreHandler.update();
        this.remodalClass.init();
        this.searchSyncSelected();

        if (typeof WOVN !== 'undefined') {
          document.addEventListener("wovnWaitAuditCompleted", this.loadingAnimation("hidden"));
          WOVN.io.triggerAudit();
        } else {
          this.loadingAnimation("hidden");
        }

        this.followBannerReflesh();

      }

      setCaseErrorFlag = () => {
        this.data.caseErrorFlag = true;
      }
      removeCaseErrorFlag = () => {
        this.data.caseErrorFlag = false;
      }

      setPageOne = () => {
        this.data.Jsons["0"].json.Page = 1;
      }
      setFilter = (target, sliderOption = null, instance = null) => {

        this.setPageOne();
        if (typeof (target) != "object") return false;


        let haveProp = this.findProp(this.data.Selectors, target);

        if (target.Type === 'list') {
          if (haveProp === false) {
            this.initItemProp(this.data.Selectors, target);
          } else {
            this.handleItemValue(this.data.Selectors, target, "add");
          }
        } else if (target.Type === "numeric") {
          if (haveProp === false) {
            this.data.Selectors.push(target);
          } else {
            if (sliderOption) {
              this.handleRangeValue(this.data.Selectors, target, sliderOption);
            }
          }
        } else if (target.Type === "text") {

          this.data.Selectors.push(target);

        } else if (target.hasOwnProperty("Page")) {
          let filterList = this.data.Jsons.filter(v => v.hasOwnProperty("json"));
          for (const prop in filterList) {
            let jsonData = filterList[prop].json;
            jsonData["Page"] = target["Page"];
          }
        }

      }
      addFilter(member, jsons) {
        let filterList = jsons.filter(v => v.hasOwnProperty("json"));
        if (filterList) {
          for (const prop in filterList) {
            filterList[prop].json.Filters = Array.from(member);
            let haveProductId = filterList[prop].json.Filters.some(v => v.PropertyId == "40");
            if (haveProductId !== true) {
              this.setGradeJsonProp(filterList[prop].json);
            }
          }
        }

      }

      removeFilter = (target, allResetFlag = null) => {
        if (typeof target !== "object") return false;
        this.setPageOne();

        if (target.Type === "list") {
          let haveProp = this.findProp(this.data.Selectors, target);

          if (haveProp === true) {
            this.handleItemValue(this.data.Selectors, target, "delete");
          }
        } else if (target.Type === "text") {
          if (allResetFlag === true) {
            // allResetFlagでサーチプロパティを除外
            this.data.Selectors = this.data.Selectors.filter(data => data.PropertyId !== target.PropertyId);
          } else {
            let removed = false; // 一度だけ削除するためのフラグ
            this.data.Selectors = this.data.Selectors.filter(data => {
              if (data.PropertyId === target.PropertyId && data.Text === target.Text && !removed) {
                removed = true; // マッチするデータが見つかったら削除フラグを設定
                return false; // このデータを削除
              }
              return true;
            });
          }
        }
      }


      setLanguage = () => {
        let langDom = document.querySelector('html').getAttribute("lang") || false;
        if (!langDom) return false;
        this.data.Jsons.forEach(dataJson => {
          if (dataJson.hasOwnProperty('json') && dataJson.json.hasOwnProperty('Language')) {
            dataJson.json.Language = this.generateLangToApi(langDom);
          }
        });
      }

      generateLangToApi = (langAttribute) => {
        //api lang [ en, ja, de, es, fr, it, pt, ru, zh, zh-cn, zh-tw ]
        if (langAttribute === "zh-Hans") return "zh";
        return langAttribute;
      }

      /**
       * jsonFilterデータの30260のex-caseのフィルターが複数存在した場合にマージする 
       * @param {*} json data.json
       * @param {*} regexClassInstance regexInstance
       */
      mergeExRegex = (jsons, regexClassInstance) => {
        let modifyJson = jsons.map(obj => {

          let jsonObject = json;
          let regexList = regexClassInstance.data;
          let regexStringList = regexList.map(regexItem => regexItem.regexData);
          let filters = jsonObject.Filters;

          // 結合用のテキストを初期化
          let combinedText = "";

          // filtersを走査し、一致するTextを|で連結
          for (let i = filters.length - 1; i >= 0; i--) {
            if (filters[i].Type === "text" && regexStringList.includes(filters[i].Text)) {
              combinedText += (combinedText ? "|" : "") + filters[i].Text;
              filters.splice(i, 1); // 一致したfilterを削除
            }
          }

          // 結合用のオブジェクトを作成
          if (combinedText) {
            const combinedObject = {
              "Type": "text",
              "PropertyId": 30260,
              "Text": combinedText,
              "AndSearch": false
            };

            // 結合用のオブジェクトを新しい配列に追加
            filters.push(combinedObject);
          }
        });

      }

      sendJson = () => {
        this.setLanguage();
        this.addFilter(this.data.Selectors, this.data.Jsons);
        this.mergeExRegex(this.data.Jsons, this.regexClass);
        this.remodalClass.destroy();
        this.suggestClass.modalHidden();

        let langAttribute = document.documentElement.lang;
        let mainAjax, sideAjax, modalAjax;

        if (langAttribute === "zh-Hans") {
          mainAjax = ajax(this.data, themeSource + 'handler/index_cn.php', 'main', this.loadingAnimation("show"));
          sideAjax = ajax(this.data, themeSource + 'handler/sidemenu_cn.php');
          modalAjax = ajax(this.data, themeSource + 'handler/modal.php');
        } else {
          sideAjax = ajax(this.data, themeSource + 'handler/sidemenu.php');
          mainAjax = ajax(this.data, themeSource + 'handler/index.php', 'main', this.loadingAnimation("show"));
          modalAjax = ajax(this.data, themeSource + 'handler/modal.php');
        }
        return Promise.all([sideAjax, mainAjax, modalAjax])
      }

      loadingEvent = () => {
        new Promise(resolve => {

          if (this.searchParam === undefined) throw new Error("searchParam is not defined");

          let searchList = this.searchParam.jsonData.filter(v => v.Type === "List");
          let numericList = this.searchParam.jsonData.filter(v => v.Type === "NumericRange" || v.Type === "Numeric");
          let textList = this.searchParam.jsonData.filter(v => v.Type === "Text");

          this.searchClass.paramLoad(searchList);
          this.sliderClass.paramLoad(numericList);
          this.textSearchClass.paramLoad(textList);

          let caseSearchParam = this.searchParam.getValue("casesearch");
          this.caseSearchClass.paramLoad(caseSearchParam);
          let checkedItems = this.searchClass.getCheckedItems();
          if (checkedItems !== null || checkedItems !== undefined) {
            this.suggestClass.syncSelectedItems(checkedItems);
          }
          this.tabMenuClass.loadEvent();

          resolve();
        }).then(result => {

          this.sendJson().then(result => {
            
            // console.log( "-", result[1] );

            let resultJson = JSON.parse(result[0]);
            let apiResponse = JSON.parse(result[1]);
            
            // console.log( "--", apiResponse );

            //apiからレスポンスがあれば、ソースコードで帰ってくるため
            if( JSON.parse( result[1] ) ){

              // console.log( "perse ");

              //apiエラー処理（返り値はjson形式）
              try {
                apiResponse = JSON.parse(result[1]);
              } catch (error) {
                console.error("Failed to parse API response:", error);
                return Promise.reject('APIレスポンスの解析に失敗しました');
              }
        
              if (apiResponse && apiResponse.stat === 'error') {
                let errorMessage;
                let langCode = wovnData.code;
        
                if (langCode !== null && langCode === "en") {
                  errorMessage = `The Data sheet and UL yellow card are currently experiencing difficulties in accessing the site. We apologize for any inconvenience caused.`;
                } else if (langCode !== null && langCode == "zh-CHS") {
                  errorMessage = `物性参数表和UL黄卡目前在访问网站时遇到困难。我们对由此造成的不便深表歉意。`;
                } else {
                  errorMessage = `物性表とUL Yellow cardは、ただいまアクセスしにくい状況が発生しております。ご不便をおかけして申し訳ありませんが、しばらく時間をおいて再度アクセスしてください。`;
                }
        
                // ローディングアニメーション画面の停止処理
                document.querySelector('.js__loading').remove();
    
                // アラートダイアログ表示
                alert(errorMessage);
    
                return Promise.reject('APIエラーが発生しました');
              }
            }

            // console.log( "---",apiResponse );


            document.querySelector('#js__out').innerHTML = apiResponse["body"];
            document.querySelector('#js__modal').innerHTML = result[2];

            // this.mainLoading.start();
            coreHandler.update();

            return resultJson;
          }).then(result => {
            this.allRebuild(result);
            this.alertClass.alertStart();
          }).catch(
            (e) => {            
              console.log( e );
            });


        });
      }




      sendClickEvent = () => {

          
          this.sendJson().then(result => {
            let resultJson = JSON.parse(result[0]);
            let apiResponse = JSON.parse(result[1]);

            
            //apiからレスポンスがあれば、ソースコードで帰ってくるため
            if( JSON.parse( result[1] ) ){


              //apiエラー処理（返り値はjson形式）
              try {
                apiResponse = JSON.parse(result[1]);
              } catch (error) {
                console.error("Failed to parse API response:", error);
                return Promise.reject('APIレスポンスの解析に失敗しました');
              }
        
              if (apiResponse && apiResponse.stat === 'error') {
                let errorMessage;
                let langCode = wovnData.code;
        
                if (langCode !== null && langCode === "en") {
                  errorMessage = `The Data sheet and UL yellow card are currently experiencing difficulties in accessing the site. We apologize for any inconvenience caused.`;
                } else if (langCode !== null && langCode == "zh-CHS") {
                  errorMessage = `物性参数表和UL黄卡目前在访问网站时遇到困难。我们对由此造成的不便深表歉意。`;
                } else {
                  errorMessage = `物性表とUL Yellow cardは、ただいまアクセスしにくい状況が発生しております。ご不便をおかけして申し訳ありませんが、しばらく時間をおいて再度アクセスしてください。`;
                }
        
                // ローディングアニメーション画面の停止処理
                document.querySelector('.js__loading').remove();
    
                // アラートダイアログ表示
                alert(errorMessage);
    
                return Promise.reject('APIエラーが発生しました');
              }
            }


            // console.log( "-----",apiResponse );

            document.querySelector('#js__out').innerHTML = apiResponse["body"];
            document.querySelector('#js__modal').innerHTML = result[2];

            // this.mainLoading.start();
            coreHandler.update();

            return resultJson;
          }).then(result => {
            this.allRebuild(result);
          }).catch((e) => console.log( e ) );

      }
      

      findProp(member, target) {
        //テキスト検索はオブジェクトを分ける。
        return member.some(v => v.PropertyId === target.PropertyId && target.Type !== "text");
      }
      initItemProp(member, target) {
        let pushObj = {
          "Type": target.Type,
          "PropertyId": (target.PropertyId),
          "ItemIds": [target.ItemId]
        }
        if (target.AndSearch) {
          pushObj.AndSearch = target.AndSearch;
        }
        member.push(pushObj);
      }

      setGradeJsonProp(jsonFilters) {

        let gradeFilter = {
          "Type": "list",
          "PropertyId": 40,
          "ItemIds": [
            1668, 1632, 496, 497
          ]
        };
          
        let langCode = wovnData.code;
        if( langCode !== "ja"){
          gradeFilter.ItemIds.push(437,438,10021);
        }

        jsonFilters.Filters.push(gradeFilter);
      }


      initRangeProp(member, target) {
        member.push(target);
      }
      handleItemValue(member, target, type) {
        //target propertyidを探索。setオブジェクトで値操作。array型に戻して_resultメンバのFilter更新。
        let
          dataIndex = member.findIndex(data => data.PropertyId === target.PropertyId),
          setArr = new Set(member[dataIndex].ItemIds);

        if (type === "add") {
          setArr.add(target.ItemId);
          member[dataIndex].ItemIds = Array.from(setArr);
        } else if (type === "delete") {
          setArr.delete(target.ItemId);
          member[dataIndex].ItemIds = Array.from(setArr);

          if (!member[dataIndex].ItemIds.length) {
            member.splice([dataIndex], 1);
          }
        }
      }
      handleRangeValue(member, target, option) {
        let dataIndex = member.findIndex(data => data.PropertyId === target.PropertyId);
        if (option[0] === Number(target.Val1) && option[1] === Number(target.Val2)) {
          member.splice([dataIndex], 1);
        } else {
          member[dataIndex].Val1 = target.Val1;
          member[dataIndex].Val2 = target.Val2;
        }
      }

      setCompareList = (target) => {
        this.data.CompareList.push(target);
        this.data.CompareList = Array.from(new Set(this.data.CompareList));
      }
      removeCompareList = (target) => {
        const index = this.data.CompareList.indexOf(target);
        this.data.CompareList.splice(index, 1);
      }

      resetSelectorList = () => {
        this.data.Selectors = this.data.Selectors.filter(v => v.Type === "numeric");
        this.sendJson();
      }
      resetCompareList = () => {
        this.data.CompareList = [];
      }
      pageBtnEvent = (data) => {
        this.setFilter(data);
        this.sendJson().then(result => {
          let resultJson = JSON.parse(result[0]);
          let apiResponse = JSON.parse(result[1]);

          
          //apiからレスポンスがあれば、ソースコードで帰ってくるため
          if( JSON.parse( result[1] ) ){


            //apiエラー処理（返り値はjson形式）
            try {
              apiResponse = JSON.parse(result[1]);
            } catch (error) {
              console.error("Failed to parse API response:", error);
              return Promise.reject('APIレスポンスの解析に失敗しました');
            }
      
            if (apiResponse && apiResponse.stat === 'error') {
              let errorMessage;
              let langCode = wovnData.code;
      
              if (langCode !== null && langCode === "en") {
                errorMessage = `The Data sheet and UL yellow card are currently experiencing difficulties in accessing the site. We apologize for any inconvenience caused.`;
              } else if (langCode !== null && langCode == "zh-CHS") {
                errorMessage = `物性参数表和UL黄卡目前在访问网站时遇到困难。我们对由此造成的不便深表歉意。`;
              } else {
                errorMessage = `物性表とUL Yellow cardは、ただいまアクセスしにくい状況が発生しております。ご不便をおかけして申し訳ありませんが、しばらく時間をおいて再度アクセスしてください。`;
              }
      
              // ローディングアニメーション画面の停止処理
              document.querySelector('.js__loading').remove();
  
              // アラートダイアログ表示
              alert(errorMessage);
  
              return Promise.reject('APIエラーが発生しました');
            }
          }


          // console.log( "-----",apiResponse );

          document.querySelector('#js__out').innerHTML = apiResponse["body"];
          document.querySelector('#js__modal').innerHTML = result[2];

          // this.mainLoading.start();
          coreHandler.update();

          return resultJson;
        }).then(result => {
          this.allRebuild(result);
        }).catch((e) => console.log( e ) );
      }

      sliderEvent = (data, [min, max]) => {
        this.setFilter(data, [min, max]);
        this.sendJson().then(result => {
          let resultJson = JSON.parse(result[0]);
          let apiResponse = JSON.parse(result[1]);

          
          //apiからレスポンスがあれば、ソースコードで帰ってくるため
          if( JSON.parse( result[1] ) ){


            //apiエラー処理（返り値はjson形式）
            try {
              apiResponse = JSON.parse(result[1]);
            } catch (error) {
              console.error("Failed to parse API response:", error);
              return Promise.reject('APIレスポンスの解析に失敗しました');
            }
      
            if (apiResponse && apiResponse.stat === 'error') {
              let errorMessage;
              let langCode = wovnData.code;
      
              if (langCode !== null && langCode === "en") {
                errorMessage = `The Data sheet and UL yellow card are currently experiencing difficulties in accessing the site. We apologize for any inconvenience caused.`;
              } else if (langCode !== null && langCode == "zh-CHS") {
                errorMessage = `物性参数表和UL黄卡目前在访问网站时遇到困难。我们对由此造成的不便深表歉意。`;
              } else {
                errorMessage = `物性表とUL Yellow cardは、ただいまアクセスしにくい状況が発生しております。ご不便をおかけして申し訳ありませんが、しばらく時間をおいて再度アクセスしてください。`;
              }
      
              // ローディングアニメーション画面の停止処理
              document.querySelector('.js__loading').remove();
  
              // アラートダイアログ表示
              alert(errorMessage);
  
              return Promise.reject('APIエラーが発生しました');
            }
          }


          console.log( "-----",apiResponse );

          document.querySelector('#js__out').innerHTML = apiResponse["body"];
          document.querySelector('#js__modal').innerHTML = result[2];

          // this.mainLoading.start();
          coreHandler.update();

          return resultJson;
        }).then(result => {
          this.allRebuild(result);
        }).catch((e) => console.log( e ) );
      }
      mergeSelector = (urlParams) => {
        this.data.Selectors = urlParams;
        this.addFilter(this.data.Selectors, this.data.Jsons);
      }


      setRecentEvent = (obj) => {
        const propertyIdToFind = obj.data.PropertyId;
        const foundData = this.data.Selectors.find(item => item.PropertyId === propertyIdToFind);

        if (foundData) {
          if (obj !== null || obj === undefined || obj.length < 1) {
            this.recentEvent = obj.data;
          }
        } else {
          this.recentEvent = null;
        }
      }

      followBannerReflesh = () => {
        this.followMenuClass.refresh();
      }

    }

    let coreHandlerInstance = new coreHandler();
    // coreHandlerInstance.instanceList.push( coreHandlerInstance );

    
      window.addEventListener("load", (() => {
        coreHandlerInstance.loadingEvent();
      })());
  }).catch(() => {
    alert("設定ファイルの読み込みに失敗しました。");
  });


}